export const screenSize = {
    mobile: '480px',
    tablet: '768px',
    desktop: '1224px',
};